import { Component, ViewChild } from '@angular/core';
import { MatMenu } from '@angular/material/menu';

@Component({ template: '' })
export abstract class AbstractCustomMenuComponent {
  @ViewChild('menu', { static: true }) menu: MatMenu;
}
